import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { MainViewState } from '../../helpers/types';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html'
})
export class NoResultsComponent {
  @Input() component: string;
  @Input() state: Observable<MainViewState>;
}
